import React from 'react';

import { Input, Tooltip, Select, Button, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { graphql, withApollo } from 'react-apollo';

import getUsuariosPorOrganismo from '../../../graphql/querys/auth/getUsuariosPorOrganismo.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getMedidas from '../../../graphql/querys/otros/getMedidas.graphql';

const FormItem = Form.Item;
const Option = Select.Option;

@graphql(getUsuario)
class FormCargarNovedad extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      listaUsuarios: [],
      listaMedidas: [],
    };

    props.client
      .query({
        query: getUsuariosPorOrganismo,
        variables: {
          idOrganismo: props.data.getUsuario.organismo._id,
        },
      })
      .then(res => {
        this.setState({
          listaUsuarios: res.data.getUsuariosPorOrganismo,
        });
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE BUSCAR LOS USUARIOS DEL ORGANISMO!');
        console.log(err);
      });

    props.client
      .query({
        query: getMedidas,
        fetchPolicy: 'network-only',
      })
      .then(res => {
        this.setState({
          listaMedidas: res.data.getMedidas,
        });
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE BUSCAR LAS MEDIDAS!');
        console.log(err);
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  crearOpciones(usuario) {
    return (
      <Option key={usuario._id} value={usuario._id}>
        {usuario.nombre + ' ' + usuario.apellido}
      </Option>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let usuario = this.props.data.getUsuario;
    let listaUsuariosOrganismo = this.state.listaUsuarios;
    let listaMedidas = this.state.listaMedidas;

    if (!listaUsuariosOrganismo) {
      return <Loading />;
    }

    var opciones = _.map(listaUsuariosOrganismo, this.crearOpciones);

    return (
      <div>
        <h1 className="tituloForm">Cargar Novedad</h1>
        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40, color: '#000000' }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Administrativos a informar
                <Tooltip title="Seleccione uno o más administrativos">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idUsuarios', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, seleccione al menos un administrativo!',
                },
              ],
            })(
              <Select
                mode="multiple"
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Seleccione uno o más administrativos"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opciones}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Tipo de Medida
                <Tooltip title="Ingrese el tipo de medida">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('tipoMedida', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el tipo de medida!',
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Seleccione un tipo de medida"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {listaMedidas.map(medida => (
                  <Option key={medida._id} value={medida.nombre}>
                    {medida.nombre}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha y Hora Desde
                <Tooltip title="Fecha y hora de inicio">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaDesde', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese la fecha y hora desde!',
                },
              ],
            })(
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="DD-MM-YYYY HH:mm"
                placeholder="Seleccionar Fecha y Hora"
                style={{ color: '#000000' }}
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha y Hora Hasta
                <Tooltip title="Fecha y hora de fin">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaHasta', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese la fecha y hora hasta!',
                },
              ],
            })(
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="DD-MM-YYYY HH:mm"
                placeholder="Seleccionar Fecha y Hora"
                style={{ color: '#000000' }}
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observaciones
                <Tooltip title="Observaciones adicionales">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observaciones', {
              rules: [
                {
                  required: false,
                },
              ],
            })(
              <Input.TextArea
                rows={4}
                style={{ width: 500, color: '#000000' }}
                placeholder="Observaciones"
              />
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(withApollo(FormCargarNovedad));
